export default __webpack_public_path__ + "static/media/kid2.07a31813.svg";